import haDateFactory from '@ha/date';
import UrlResolver from 'ha/helpers/UrlResolver';
import createTranslateFunction from './createTranslateFunction';
import createNumberFormatters from './createNumberFormatters';
import { IntlConfig, IntlObject } from './types';
import getLocaleForLanguage from './getLocaleForLanguage';

export default function createIntl({
  lang,
  baseDomain,
  messages,
}: IntlConfig): IntlObject {
  const locale = getLocaleForLanguage(lang);
  const haDate = haDateFactory(locale);

  return {
    lang,
    locale,
    messages,
    T: createTranslateFunction(messages),
    urlResolver: UrlResolver.create({
      baseDomain,
      lang,
    }),
    formatDate: haDate.formatDate,
    fromNow: haDate.fromNow,
    toLocalizedString: haDate.toLocalizedString,
    ...createNumberFormatters(locale),
  };
}
